<template>
	<div class="my-demo" @click="addCart"
		:style="{border:selectdItem.preStyle.border.px == 0?'solid 1px #000000':'','--hover': compontentStyle.hoverColor,'--bgcolor': selectdItem.preStyle.font.color?selectdItem.preStyle.font.color:'#ffffff','--color': selectdItem.preStyle.font.color?'#ffffff':'#000000'}"
		style="height: 100%;width: 100%;display: flex;justify-content: center;bo">
		<div class="linktit" style="margin: 10px;display: flex;align-items: center;">
			<i :style="{fontSize:(selectdItem.preStyle.font.size + 2)+ 'px'}" class="el-icon-shopping-cart-2"></i>
			<div :style="{fontSize:(selectdItem.preStyle.font.size -3)+ 'px'}" style="margin-left: 10px;">{{getLangurge()}}</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	export default {
		props: {
			type: {
				type: String,
				default: "design"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		watch: {
			selectdItem: {
				handler: function(newV, oldV) {
					console.log('newV,', newV)
				},
				immediate: true,
				deep: true
			}
		},
		computed: {
			...mapState("lowCodeStore", ['num'])
		},
		data() {
			return {

			}
		},
		mounted() {
			console.log('mountedmounted', this.systemConfig)
		},
		methods: {
			getLangurge() {
				let obj = {
					'zh_cn':'加入购物车',
					'en':'Add to cart',
					'zh_hk':'加入購物車',
					'ja':'ショッピングカートに入れる',
					'ko':'장바구니 넣기',
					'de':'Zum Warenkorb hinzufügen',
					'es':'agregar al carrito',
					'fr':'ajouter au panier',
					'id':'Tambahkan ke Keranjang',
					'it':'Aggiungi al carrello',
					'ru':'добавить в корзину',
				}
				return obj[this.systemConfig.locale]
				
			},
			addCart() {
				if (this.type != 'build') {
					console.log('加入购物车')
					
					
					
				} else {
					// 有商品的 id 数量
				}

			}
		}
	}
</script>

<style scoped>
	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}

	.my-demo:active {
		background-color: var(--bgcolor);
		color:var(--color);
	}
</style>